import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
import { brand } from '@helpers/brand';
import SvgChevronDown from '@img/icons/chevron-down-thin.svg?url';
import Button from '../../Buttons/Button/Button';
import srOnly from '@helpers/srOnly';
const Container = styled.section `

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 24px;
  }

  @media ${from(Device.Desktop)} {
    padding: 24px 0;
  }
`;
const FilterTop = styled.div `
  background-color: ${brand.lightGrey};
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
`;
const FilterBase = styled.div `
  background-color: ${brand.lightGrey};
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const PageIndex = styled.span `
  flex: 7 0 auto;
  font-size: 16px;
  line-height: 24px;
`;
const FilterList = styled.div `
  display: flex;
  flex: 1 1 auto;
`;
const Filter = styled.div `
  display: block;
  flex: 1 1 auto;
  margin-left: 16px;
  position: relative;

  @media ${from(Device.Desktop)} {
    margin-left: 20px;
  }
`;
const SelectLabel = styled.label `
  ${srOnly};
`;
const FilterDropdown = styled.select `
  ${fonts.montserrat.medium};
  display: block;
  width: 100%;
  border: 2px solid ${brand.black};
  appearance: none !important;
  background: none;
  background-color: ${brand.white};
  background-image: url('${SvgChevronDown}');
  background-repeat: no-repeat;
  background-position: center right 12px;
  background-size: 24px 12px;
  border-radius: 8px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 30px 0 12px;
  width: 100%;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 20px;
  }

  ${FilterBase} & {
    ${fonts.montserrat.bold};
    height: 47px;
    font-size: 15px;
    line-height: 20px;
  }
`;
const FilterSearch = styled.input `
  ${fonts.montserrat.regular};
  display: block;
  appearance: none;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 30px 0 12px;
  flex: 1 0 auto;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 20px;
  }
`;
const FilterSearchBtn = styled(Button) `
  margin-left: 20px;
  height: 56px;
`;
const FilterHolder = styled.div `
  flex: 1 0 auto;
`;
export default {
    Container,
    Filter,
    FilterBase,
    FilterDropdown,
    FilterSearch,
    FilterSearchBtn,
    FilterHolder,
    FilterList,
    FilterTop,
    PageIndex,
    SelectLabel,
};
